export const colors = {
  text: {
    dark: '#2F3160',
    grey: '#5E5F77',
    pink: '#FF6489',
  },
  bg: {
    dark: '#454887',
    lightDark: '#6064BA',
  },
};
